import { ReactNode, useState } from 'react';
import { Root, Content, Trigger } from '@radix-ui/react-collapsible';
import { clsx } from 'clsx';

type CollapsibleCardProps = {
  title?: string;
  className?: string;
  children: ReactNode;
};

const Icon = ({ className = '' }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M15 12.5L10 7.5L5 12.5"
      stroke="#2A2E3A"
      strokeWidth="1.67"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CollapsibleCard = ({ title = '', className = '', children }: CollapsibleCardProps) => {
  const [open, setOpen] = useState(true);

  return (
    <div className={clsx('p-4 bg-white rounded-sm-5', className)}>
      <Root open={open} onOpenChange={setOpen} className={'gap-4'}>
        {title && (
          <Trigger className={'flex flex-row w-full justify-between items-center py-2'}>
            <div className={'text-lg text-text_primary font-bold leading-[150%]'}>{title}</div>
            <div>
              <Icon
                className={clsx(
                  'expand-collapse-icon transition-all',
                  open ? 'rotate-0' : 'rotate-180',
                )}
              />
            </div>
          </Trigger>
        )}
        <Content
          className={
            'grid w-full gap-2 transition-all duration-300 ease-in-out data-[state=closed]:opacity-0 data-[state=closed]:animate-collapsible-up-grid data-[state=open]:opacity-100 data-[state=open]:animate-collapsible-down-grid'
          }
        >
          {children}
        </Content>
      </Root>
    </div>
  );
};
